export default __webpack_public_path__ + "static/media/home-qualification21mobile.cdda7216.png";